import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';
import pinMark from "../../assets/pin-mark.svg";
import LinkAccountBanner from "../../assets/link-account-banner.svg";
import Close_black from "../../assets/close_black.svg";
import LinkAccountBorder from "../../assets/dashed-line.svg";
import LinAccount1 from "../../assets/new-link-account-1.svg";
import LinAccount2 from "../../assets/new-link-account-2.svg";
import LinAccount3 from "../../assets/new-link-account-3.svg";
import instaLinkImg from "../../assets/instagram-link.svg";
import { useToast } from "../../toast";
import { addOldAccount, onAddCreator, onCheckAccounts, onCheckValidateCreator } from '../../services';
import { useDispatch, useSelector } from 'react-redux';
import $ from "jquery";
import { CREACTOR_DETAILS, REGISTER_DETAILS } from '../../redux/action_type';
import { onGetProfileDetails, onJustReducerUpdate } from '../../redux/action';
import { useHistory } from 'react-router-dom';
import { confirmAlertCommon } from "../common/confirmAlertCommon";
import socialIcon1 from "../../assets/insta-icon.svg";
import socialIcon2 from "../../assets/facebook-icon.svg";
import socialIcon3 from "../../assets/youtube-icon.svg";
import socialIcon4 from "../../assets/twitter-icon.svg";
import { isValidUrl } from '../../utils/common';
import IsLoadingHOC from '../HOC/loader/IsLoadingHOC';
import _ from "lodash";

function LinkAccount(props) {
    const socialMediaOptions = [
        { value: 'instagram', label: 'Instagram', icon: socialIcon1 },
        { value: 'facebook', label: 'Facebook', icon: socialIcon2 },
        { value: 'youtube', label: 'Youtube', icon: socialIcon3 },
    ]
    const profileDetails = useSelector((state) => state.profileDetails)
    const profileDetailsLoading = useSelector((state) => state.profileDetailsLoading)
    const toast = useToast();
    const dispatch = useDispatch()
    const history = useHistory();
    const { Option } = components;
    const [isClearable, setIsClearable] = useState(true);
    const [isSearchable, setIsSearchable] = useState(true);
    const [isDisabled, setIsDisabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRtl, setIsRtl] = useState(false);
    const [selectedOption, setSelectedOption] = useState({ value: 'instagram', label: 'Instagram' });
    const [channelName, setChannelName] = useState("");
    const prefix = '@'
    const { setLoading } = props;
    let authData = localStorage.getItem(REGISTER_DETAILS)
    authData = JSON.parse(authData)
    useEffect(() => {
        setLoading(profileDetailsLoading)
    }, [profileDetailsLoading])

    useEffect(() => {
        if (profileDetailsLoading || _.isEmpty(profileDetails)) {
            return
        }
        if ((profileDetails?.cp_creators?.length === 0 || !profileDetails?.cp_creators?.length) && !profileDetailsLoading) {
            history.push("/link-account");
        } else if (!profileDetailsLoading && !_.isEmpty(profileDetails?.cp_creators)) {
            const { publisher_id, is_linked } = profileDetails?.cp_creators?.[0]
            if (is_linked) {
                history.push("/dashboards");
                return
            } else {
                setLoading(true)
                addOldAccount({ publisher_id, is_deleted: true }).then(responseData => {
                    setLoading(false)
                    if (responseData.status) {
                        dispatch(onGetProfileDetails(authData.josh_user_id))
                    }
                }).catch(err => console.log("err3", err))
            }
        }
    }, [profileDetails, profileDetailsLoading])

    const IconOption = props => {
        return (
            <Option {...props} className="select-option">
                <img
                    className='drop-down-img'
                    src={props?.data?.icon}
                    style={{ width: 36 }}
                    alt={props.data.label}
                />
                {props.data.label}
            </Option>
        )
    };

    const handleChange = (e) => {
        setSelectedOption(e);
    };

    const onCheck = () => {
        let contructChannelName = channelName.split("/")?.filter(n => n)?.slice(-1).pop()
        if (!contructChannelName || !profileDetails?.name || !selectedOption?.value) {
            toast.open("Please add the profile name", "warn")
            console.log("please check the values")
            return
        }
        setLoading(true)
        contructChannelName = contructChannelName.split("@")?.slice(-1).pop()
        let payload = {
            "publisher_name": profileDetails?.name,
            "network": selectedOption?.value,
            "userid": contructChannelName
        }
        onCheckValidateCreator(payload).then((res) => {
            if (res.status) {
                const validateResponse = res.data
                if (validateResponse.new_status && validateResponse.is_delete) {
                    payload = { ...payload, is_delete: true, publisher_id: validateResponse.publisher_id, socialNetworkId: validateResponse?.socialNetworkId }
                    onAddCreator(payload).then((response) => {
                        setLoading(false)
                        $("#link-account-popup-1").modal("hide");
                        setSelectedOption([])
                        setChannelName("")
                        if (response.status) {
                            toast.open(response?.message)
                            dispatch(onJustReducerUpdate(response.data, CREACTOR_DETAILS))
                            history.push("/account-authentication")
                        }
                    })
                } else if (validateResponse.new_status && !validateResponse.is_delete) {
                    payload = { ...payload, is_delete: false, publisher_id: 0, socialNetworkId: validateResponse?.socialNetworkId }
                    onAddCreator(payload).then((response) => {
                        setLoading(false)
                        $("#link-account-popup-1").modal("hide");
                        setSelectedOption([])
                        setChannelName("")
                        if (response.status) {
                            toast.open(response?.message)
                            dispatch(onJustReducerUpdate(response.data, CREACTOR_DETAILS))
                            history.push("/account-authentication")
                        }
                    })
                } else if (validateResponse.error) {
                    setLoading(false)
                    toast.open(res?.message, "error")
                    $("#link-account-popup-1").modal("hide");
                    setSelectedOption([])
                    setChannelName("")
                }
            } else {
                setLoading(false)
            }
        }).catch((err) => {
            setLoading(false)
            console.log("err", err)
        })
    }

    const onValueChange = (value) => {
        setChannelName(value)
    }

    const onClose = () => {
        setSelectedOption({ value: 'instagram', label: 'Instagram' })
        setChannelName("")
    }

    if (profileDetailsLoading || !_.isEmpty(profileDetails.cp_creators)) {
        return
    }

    const handleKeyPress = (e) => {
        if (e.keyCode === 13 && e.target.value != "") {
            onCheck()
        }
    }

    return (
        <>
            <div className='middle-content-wrap'>
                <div className='link-account-wrap'>
                    <div className='link-accunt-banner'>
                        <p>Get associated over <a href="/#">Top 100+ Brands</a></p>
                        <span>Creator dashboard allows you to open up your social accounts to branded campaigns
                            and affiliate  marketing <br /> opportunities</span>
                        <div className='common-btn'>
                            <button><img src={pinMark} alt="" /> Link Account</button>
                        </div>
                        <img className='link-act-banner' src={LinkAccountBanner} alt="" />
                        <img className='link-act-border' src={LinkAccountBorder} alt="" />
                    </div>

                    <div className='link-account-card-wap'>
                        <div className='heading'>
                            What are the benefits ?
                        </div>
                        <div className='row'>
                            <div className='col-md-4'>
                                <div className='link-account-card'>
                                    <img src={LinAccount1} alt="" />
                                    <p>Campaign Invites</p>
                                    <ul>
                                        <li>Get invited from over 100+ Brands for the campaign associations and monetization opportunities.</li>

                                    </ul>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='link-account-card'>
                                    <img src={LinAccount2} alt="" />
                                    <p>Social Performance</p>
                                    <ul>
                                        <li>Get detailed performance insights on all linked Social accounts with easy share account reports.</li>
                                    </ul>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='link-account-card'>
                                    <img src={LinAccount3} alt="" />
                                    <p>Affiliate Program</p>
                                    <ul>
                                        <li>Access to 1000+ affiliate products from top brands. Grow your social profile & earn money while creating content.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className='common-btn'>
                            <button><img src={pinMark} alt="" /> Link Account</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Link Account Popup Start Here */}
            <div
                className="modal fade logout-popup-wrap link-account-popup"
                id="link-account-popup-1"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                data-backdrop="static"
                data-keyboard="false"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered custom-popup " role="document">

                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Link Account
                            </h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span aria-hidden="true">
                                    <img src={Close_black} alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body ">
                            <div className='link-account-popup-wrap'>
                                <img src={instaLinkImg} alt="" />
                                <p>Add your primary social account handle for brand campaigns</p>

                                <div className='link-account-options'>

                                    <div className='form-group'>
                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select"
                                            isDisabled={isDisabled}
                                            isLoading={isLoading}
                                            isClearable={false}
                                            isRtl={isRtl}
                                            isSearchable={false}
                                            options={socialMediaOptions}
                                            name="color"
                                            onChange={handleChange}
                                            value={selectedOption}
                                            components={{ Option: IconOption }}
                                            formatOptionLabel={data => {
                                                return (
                                                    <div className="country-option">
                                                        <img
                                                            className='drop-down-img-label'
                                                            src={data.value === "instagram" ? socialIcon1 : data.value === "facebook" ? socialIcon2 : data.value === "youtube" ? socialIcon3 : socialIcon4}
                                                            style={{ width: 36 }}
                                                            alt={data.label}
                                                        />
                                                    </div>
                                                )
                                            }}
                                        />
                                        <input
                                            type="text"
                                            className="form-control"
                                            onKeyDown={handleKeyPress}
                                            onChange={(e) => {
                                                const input = e.target.value
                                                if (isValidUrl(input)) {
                                                    e.target.value = input
                                                } else {
                                                    setChannelName((prev) => {
                                                        if (prev.length === 0) {
                                                            e.target.value = prefix + input
                                                        } else {
                                                            e.target.value = prefix
                                                            if (input.length > 0) {
                                                                e.target.value = prefix + input.substr(prefix.length)
                                                            } else {
                                                                e.target.value = ""
                                                            }
                                                        }
                                                        onValueChange(e.target.value)
                                                        return
                                                    })
                                                }
                                                onValueChange(e.target.value)
                                            }}
                                            value={channelName}
                                            placeholder='Enter your URL or User Name'
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="modal-footer">
                            <div className='common-btn'>
                                <button type='button' className={`${!channelName ? "link-btn-disabled" : ""}`} disabled={!channelName} onClick={onCheck}><img src={pinMark} alt="" /> Link Account</button>
                                {/* <button data-dismiss="modal">Cancel</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Link Account Popup End Here */}
            {/* Session Popup Start Here */}
            <div
                className="modal fade logout-popup-wrap session-popup"
                id="link-account-popup-2"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                data-backdrop="static"
                data-keyboard="false"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered custom-popup " role="document">
                    <div className="modal-content   ">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">

                            </h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span aria-hidden="true">
                                    <img src={Close_black} alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body ">
                            <div className='logout-card'>
                                <h2> Link Account</h2>
                                <p>Link your account before session expires.</p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className='common-btn'>
                                <button data-dismiss="modal">Link</button>
                                <button data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Session Popup End Here */}
            {/* Session Expired  Popup Start Here */}
            <div
                className="modal fade logout-popup-wrap session-popup"
                id="link-account-popup-3"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                data-backdrop="static"
                data-keyboard="false"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered custom-popup " role="document">
                    <div className="modal-content   ">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">

                            </h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span aria-hidden="true">
                                    <img src={Close_black} alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body ">
                            <div className='logout-card'>
                                <h2>Session Expired</h2>
                                <p>Link your account again</p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className='common-btn'>
                                <button data-dismiss="modal">Link</button>
                                <button data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Session Expired Popup End Here */}
            {/* Social Link Account Popup Start Here */}
            <div
                className="modal fade logout-popup-wrap session-popup social-link-account"
                id="link-account-popup-4"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                data-backdrop="static"
                data-keyboard="false"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered custom-popup " role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">

                            </h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span aria-hidden="true">
                                    <img src={Close_black} alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body ">
                            <div className='logout-card'>
                                <h2>Link Social Accounts</h2>
                                <p>We have found your other social accounts and added them to your profile</p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className='common-btn'>
                                <button data-dismiss="modal">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Social Link Account Popup Start Here */}
        </>
    )
}

export default IsLoadingHOC(LinkAccount)